import { SceneView } from "./SceneView"
import { SceneFrame } from "../Components/Scene"

export interface QuickStartVoyageSceneViewProps {
  onClose?: () => void;
}

export const quickStartVoyageFrames: SceneFrame[] = [
  {
    animations: ["auto-show-overlay"],
    content: "start_quickstart_voyage",
    contentOptions: { theme: "dark" },
    name: "startVoyage",
    overlayPosition: "hide",
  },
  {
    content: "start_quickstart_voyage",
    name: "startVoyage",
    overlayPosition: "center",
  },
  {
    action: { action: "click", selector: ".ShipView-menus > button:has(.LogbookIcon), button.focus" },
    animations: ["show-action-click"],
    content: "new_ship_ready",
    name: "startPassage",
    overlayPosition: "bottom-center",
  },
  {
    content: "focus_start",
    highlight: ".CruiseView-title span.title, .TripView-title",
    name: "startPassage2",
    overlayPosition: "top-right",
  },
  {
    content: "focus_start",
    name: "startPassage3",
    overlayPosition: "top-right",
    highlight: ".TripEditView .block_field_small_10",
  },
  {
    action: { action: "click", selector: ".TripEditView button.start-trip" },
    animations: ["show-action-click"],
    content: "trip_name",
    name: "startPassage4",
    overlayPosition: "top-right",
  },
  {
    animations: [
      "scroll-to-logrow",
      "show-pointer",
    ],
    content: "day_started",
    highlight: ".LogView-current-entry",
    name: "startPassage5",
    overlayPosition: "top-right",
  },
  {
    action: { action: "click", selector: ".crew-select .Select > .button" },
    animations: ["scroll-to-logrow", "show-action-click"],
    content: "day_data",
    name: "dayData",
    overlayPosition: "top-right",
  },
  {
    animations: ["scroll-to-top"],
    content: "day_data2",
    name: "dayData2",
    overlayPosition: "bottom-right",
  },
  {
    animations: ["scroll-to-logrow"],
    content: "engine1_on",
    highlight: "[data-log-id=\"1\"]",
    name: "engine1",
    overlayPosition: "top-center",
  },
  {
    content: "engine2_on",
    highlight: "[data-log-id=\"2\"]",
    name: "engine2",
    overlayPosition: "top-center",
  },
  {
    animations: [
      "scroll-to-logrow",
    ],
    content: "started",
    highlight: ".DayView-logs-log:has(.LogView-current-entry) .status-button",
    name: "departing",
    overlayPosition: "top-center",
  },
  {
    animations: [
      "scroll-to-logrow",
      "show-pointer-up",
    ],
    content: "started",
    highlight: ".ShipView-menus .Menu-button:has(.ShipView-status-ok)",
    name: "departing2",
    overlayPosition: "top-center",
  },
  {
    animations: [
      "scroll-to-logrow",
    ],
    content: "entry_30min",
    highlight: "[data-log-id=\"4\"]",
    name: "logEntries2",
    overlayPosition: "top-center",
  },
  {
    animations: [
      "scroll-to-logrow",
    ],
    content: "manualEntry_scene",
    highlight: ".DayView-logs-log:has(.LogView-current-entry) .LogButton",
    name: "manualEntry",
    overlayPosition: "top-center",
  },
  {
    action: { action: "click", selector: ".DayView-logs-log:has(.LogView-current-entry) .LogButton .Menu-button" },
    animations: [
      "scroll-to-logrow",
      "show-action-click",
    ],
    content: "manualEntry_scene",
    name: "manualEntry1a",
    overlayPosition: "top-center",
  },
  {
    content: "manualEntry_scene",
    highlight: ".LogButton .Menu-items",
    name: "manualEntry1b",
    overlayPosition: "top-center",
  },
  {
    action: { action: "click", selector: ".LogButton-sails-block .LogButton-sail-container:first-child .LogButton-sail-btn" },
    animations: [
      "keep-on-nextday",
      "show-action-click-once",
    ],
    content: "manualEntry_scene",
    name: "sail_entry1",
    overlayPosition: "top-center",
  },
  {
    animations: [
      "keep-on-nextday",
    ],
    content: "manualEntry_scene",
    highlight: ".LogButton-sail-confirm",
    name: "selectSail2",
    overlayPosition: "top-center",
  },
  {
    content: "sail_entry2",
    highlight: ".LogButton-sail-confirm",
    name: "sail_entry3",
    overlayPosition: "top-center",
  },
  {
    content: "entries_engines_off",
    name: "logEntries3",
    overlayPosition: "top-center", // marker at engine titles
  },
  {
    action: { action: "click", selector: "[data-log-id=\"7\"]" },
    animations: [
      "scroll-to-nextday",
      "show-action-click",
    ],
    content: "entries_engines_off",
    highlight: "[data-log-id=\"7\"]",
    name: "logEntries4",
    overlayPosition: "top-center",
  },
  {
    content: "entry_additional_data",
    name: "logEntries5",
    overlayPosition: "top-center",
  },
  {
    content: "entry_additional_data2",
    name: "logEntries6",
    overlayPosition: "top-center",
  },
  {
    content: "course_change",
    name: "logEntries7",
    highlight: "[data-log-id=\"8\"]",
    overlayPosition: "top-center",
  },
  {
    content: "manual_engine_entry",
    highlight: ".DayView-logs-log:has(.LogView-current-entry) .engine-icons",
    name: "manualEntry3",
    overlayPosition: "top-center",
  },
  {
    content: "manual_engine_entry",
    name: "manualEntry4",
    overlayPosition: "top-center",
  },
  {
    animations: [
      "scroll-to-nextday",
    ],
    content: "sailing",
    name: "logEntries8",
    overlayPosition: "top-center",
  },
  {
    animations: [
      "show-pointer",
    ],
    content: "pause",
    highlight: ".DayView-logs-log:has(.LogView-current-entry) .LogView-header",
    name: "endDay",
    overlayPosition: "top-center",
  },
  {
    content: "pause_dialog",
    name: "endDay2",
    overlayPosition: "bottom-center",
  },
  {
    action: { action: "click", selector: ".UserAdviceStopView button.default[type=\"submit\"]" },
    animations: ["show-action-click"],
    content: "pause_set",
    name: "endDay3",
    overlayPosition: "bottom-center",
  },
  {
    content: "pause_fixed",
    highlight: "[data-log-id='18'] .status-button",
    name: "endDay4",
    overlayPosition: "top-center",
  },
  {
    content: "pause_fixed2",
    name: "endDay5",
    overlayPosition: "top-center",
  },
  {
    content: "engines_off",
    name: "endDay6",
    overlayPosition: "top-center",
  },
  {
    content: "engines_off",
    name: "endDay7",
    overlayPosition: "top-center",
  },
  {
    animations: [
      "scroll-to-nextday",
    ],
    content: "next_day",
    name: "nextDay",
    overlayPosition: "top-center",
  },
  {
    content: "next_day_ready",
    name: "nextDay2",
    overlayPosition: "top-right",
  },
  {
    content: "next_day_engines",
    name: "nextDay3",
    overlayPosition: "top-center",
  },
  {
    content: "next_day_started",
    name: "nextDay4",
    overlayPosition: "top-center",
  },

  // End screen with buttons to other screencasts
  {
    animations: ["fade-in-content"],
    content: "end",
    name: "final2",
    overlayPosition: "bottom-center",
  },
];

export function QuickStartVoyageSceneView({ onClose }: QuickStartVoyageSceneViewProps) {
  return <SceneView onClose={onClose} scene="quickstart-voyage" frames={quickStartVoyageFrames} />;
}
